<template>
  <div>
    <h2>Easter Eggs</h2>
    <p>
      Nobody can read the Original Works tags. Nobody. Nor can they read Crossover Fandom. Please
      use your own good judgement to figure out which tag belongs to which category in this list..
    </p>
    <div class="form-horizontal columns">
      <div class="form-group column col-5">
        <div class="col-5 col-sm-12">
          <label class="form-label" for="fandom-filter">
            Search Tags
          </label>
        </div>
        <div class="col-7 col-sm-12">
          <input
            class="form-input"
            type="text"
            id="tag-filter"
            placeholder="Search..."
            v-model="term"
          />
        </div>
      </div>
    </div>

    <!-- form structure -->

    <table class="bonus table">
      <thead>
        <tr>
          <th class="tag">
            Tag
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="value in list" :key="value.username">
          <td>{{ value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from "lodash";
import Fuse from "fuse.js";
import tags from "../data/ow.json";
let search = new Fuse(tags, {
  shouldSort: true,
  tokenize: false,
  matchAllTokens: false,
  findAllMatches: true,
  threshold: 0.3,
  location: 0,
  distance: 500,
  maxPatternLength: 32,
  minMatchCharLength: 3,
  keys: []
});
export default {
  data() {
    return {
      tags,
      sortOrder: "asc",
      term: ""
    };
  },
  methods: {
    sort(field) {
      if (this.sortBy === field) {
        if (this.sortOrder === "asc") {
          this.sortOrder = "desc";
        } else {
          this.sortOrder = "asc";
        }
      } else {
        this.sortBy = field;
      }
    },
    filter(type) {
      switch (type) {
        case "heroes":
          this.maxGifts = 0;
          this.minWritten = 1;
          this.minAvg = 0;
          this.minTotal = 0;
          this.minMax = 0;
          this.minichallenge = "";
          this.sortBy = "written";
          this.sortOrder = "desc";
          break;
        case "longfic":
          this.maxGifts = 100;
          this.minWritten = 1;
          this.minAvg = 0;
          this.minTotal = 0;
          this.minMax = 10000;
          this.minichallenge = "";
          this.sortBy = "maxWords";
          this.sortOrder = "desc";
          break;
        case "prolific":
          this.maxGifts = 100;
          this.minWritten = 3;
          this.minAvg = 0;
          this.minTotal = 0;
          this.minMax = 0;
          this.minichallenge = "";
          this.sortBy = "written";
          this.sortOrder = "desc";
          break;
        case "avg":
          this.maxGifts = 100;
          this.minWritten = 2;
          this.minAvg = 2000;
          this.minTotal = 0;
          this.minMax = 0;
          this.minichallenge = "";
          this.sortBy = "avgWords";
          this.sortOrder = "desc";
          break;
        case "nano":
          this.maxGifts = 100;
          this.minWritten = 0;
          this.minAvg = 0;
          this.minTotal = 50000;
          this.minMax = 0;
          this.minichallenge = "";
          this.sortBy = "totalWords";
          this.sortOrder = "desc";
          break;
        case "minichallenge":
          this.maxGifts = 100;
          this.minWritten = 0;
          this.minAvg = 0;
          this.minTotal = 0;
          this.minMax = 0;
          this.sortBy = "username";
          this.minichallenge = "Any";
          this.sortOrder = "asc";
          break;
        default:
          break;
      }
    }
  },
  computed: {
    list() {
      if (this.term && this.term.length) {
        const indices = search.search(this.term);
        const res = [];
        _.each(indices, i => {
          res.push(this.tags[i]);
        });
        return res;
      }
      return this.tags;
    }
  }
};
</script>

<style scoped lang="scss">
.btn {
  margin: 10px 10px 0 0;
}

// .th-small {
//   width: 80px;
// }

.username {
  width: 150px;
}
</style>
